import { resolveMerchStoreApiUrl } from '../api/merchstore';
import * as types from '../constants/ActionTypes';
import http from '@merchstores/frontend/utils/http';

/* * * Store * * */
export const fetchStore = (subdomain: string) => (dispatch: any) => {
  dispatch({
    type: types.FETCH_STORE_INFO_START,
  });

  http
    .post(
      resolveMerchStoreApiUrl(
        '/.netlify/functions/merchstore-api/fetchMerchStoreBySubdomain'
      ),
      { subdomain }
    )
    .then((res: any) => {
      //TODO view response
      const merchstore = res.data;
      dispatch({
        type: types.FETCH_STORE_INFO_END,
        merchstore,
      });
    })
    .catch((err) => {
      console.error(err);
      dispatch({
        type: types.FETCH_STORE_INFO_ERROR,
      });
    });
};
